const byQuerySpot = ({ region, zipCode, spot }: any) => {
  if (zipCode) {
    return [
      {
        type: 'zipCode',
        label: spot,
        value: zipCode,
      },
    ];
  }
  if (region) {
    return [
      {
        type: 'postcode',
        label: spot,
        value: region,
      },
    ];
  }
  return undefined;
};

export default byQuerySpot;
